import { MenuItems } from './../../../core/model/menu-items';
import {Component, Input} from '@angular/core';  
import { Permission } from 'app/core/model/permission';
@Component({  
    selector: 'tree-view',      
    templateUrl: './tree-view.html',  
    styleUrls: ['./tree-view.css']      
})  
export class TreeView {  
    @Input() childNode: MenuItems;  
    //@Input() menuList: MenuItems;


    getPermission(m : MenuItems){
        let permission : Permission = new Permission();
        let employeeType : number[]=[];
       //console.log(m);
       //console.log(m.permission);
       //console.log(m.permission[0]);
       //console.log(m.permission[0].flg_add);
  
        permission.windowTitle = m.nameItem;
        permission.flgEmployeeType = m.flgEmployeeType;
        permission.flg_add =m.permission[0].flg_add;
        permission.flg_edit = m.permission[0].flg_edit;
        permission.flg_delete = m.permission[0].flg_delete;
        permission.flg_view = m.permission[0].flg_view;
        permission.flg_calculate = m.permission[0].flg_calculate;
        permission.flg_export = m.permission[0].flg_export;
         
          if(m.flgEmployeeType == true){
            for(var i= 0;i<m.permission.length ; i++){
              employeeType.push(m.permission[i].employee_type_id);
            }
          }
        permission.employeeType = employeeType;
        sessionStorage.setItem('currentPermission', JSON.stringify(permission));
      }
      
}  




// WEBPACK FOOTER //
// ./src/app/shared/layout/navigation/tree-view.component.ts